<div *ngIf="heeftLoon()">

    <form [formGroup]="specLoonFormGroup">
        <div formGroupName="specificatieLoon">
            <div formGroupName="opbouw">
                <div >
                    <div class="row">
                        <div class="col col-1">
                            Inkomsten uit loondienst
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="loonUitTegenwoordigeDienstbetrekking"
                                    id="loonUitTegenwoordigeDienstbetrekking"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
                <div *ngIf="this.isDefAangifte">
                    <div *ngIf="specLoon.specificatieLoon?.opbouw?.reisaftrekOpenbaarVervoer !== undefined "
                         class="left">
                        <div class="row">
                            <div class="col col-1">
                                Af: Reisaftrek openbaar vervoer
                            </div>

                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="reisaftrekOpenbaarVervoer"
                                        id="reisaftrekOpenbaarVervoer"
                                        prefix="€ -"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                    <div *ngIf="specLoon.specificatieLoon?.opbouw?.vergoedingReisaftrek !== undefined && specLoon.specificatieLoon?.opbouw?.vergoedingReisaftrek !== 0"
                         class="left">
                        <div class="row">
                            <div class="col col-1">
                                Bij: Vergoeding werkgever openbaar vervoer
                            </div>

                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="vergoedingReisaftrek"
                                        id="vergoedingReisaftrek"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
                <div *ngIf="specLoon.specificatieLoon?.opbouw?.loonUitVroegereDienstbetrekking !== undefined"
                     class="left">
                    <div class="row">
                        <div class="col col-1">
                            Pensioen en andere uitkeringen
                        </div>

                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="loonUitVroegereDienstbetrekking"
                                    id="loonUitVroegereDienstbetrekking"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
                <div *ngIf="specLoon.specificatieLoon?.opbouw?.loonUitTegenwoordigeDienstbetrekkingBuitenland !== undefined &&
                                                    specLoon.specificatieLoon?.opbouw?.loonUitTegenwoordigeDienstbetrekkingBuitenland!.valueOf() !== 0"
                     class="left">
                    <div class="row">
                        <div class="col col-1">
                            Loon uit buitenlandse dienstbetrekking (tegenw.)
                        </div>

                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="loonUitTegenwoordigeDienstbetrekkingBuitenland"
                                    id="loonUitTegenwoordigeDienstbetrekkingBuitenland"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
                <div *ngIf="specLoon.specificatieLoon?.opbouw?.loonUitVroegereDienstbetrekkingBuitenland !== undefined &&
                                                  specLoon.specificatieLoon?.opbouw?.loonUitVroegereDienstbetrekkingBuitenland!.valueOf() !== 0"
                     class="left">
                    <div class="row">
                        <div class="col col-1">
                            Loon uit buitenlandse dienstbetrekking (vroeger)
                        </div>

                        <div class="col-2">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="loonUitVroegereDienstbetrekkingBuitenland"
                                    id="loonUitVroegereDienstbetrekkingBuitenland"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="berekeningBox1FormGroup">
        <div formGroupName="box1">
            <div formGroupName="opbouwInkomen">
                <div class="left">
                    <div class="row">
                        <div *ngIf="!this.partnerBoolean" class="col col-1">
                            <p><b>Totaal belastbaar loon {{ dataService.naamAangever }}</b></p>
                        </div>
                        <div *ngIf="this.partnerBoolean" class="col col-1">
                            <p><b>Totaal belastbaar loon {{ dataService.naamPartner }}</b></p>
                        </div>
                        <div class="col-2"></div>
                        <div class="col-3">
                            <snelstart-ui-number-form-control
                                    [decimals]="0"
                                    align="right"
                                    class="custom-input-150"
                                    formControlName="belastbaarloon"
                                    id="belastbaarloon"
                                    placeholder="-"
                                    prefix="€"
                            ></snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="specLoonFormGroup">
        <div class="row pt-3">
            <div formGroupName="specificatieLoon">
                <div formGroupName="opbouw">
                    <div *ngIf="specLoon.specificatieLoon?.opbouw?.loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie !== undefined"
                         class="left">
                        <div class="row">
                            <div class="col col-1">
                                Vrijgesteld loon uit internationale organisatie (tegenw.)
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie"
                                        id="loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                    <div *ngIf="specLoon.specificatieLoon?.opbouw?.loonUitVroegereDienstbetrekkingInternationaleOrganisatie !== 0 &&
                                                      specLoon.specificatieLoon?.opbouw?.loonUitVroegereDienstbetrekkingInternationaleOrganisatie !== undefined"
                         class="left">
                        <div class="row">
                            <div class="col col-1">
                                Vrijgesteld loon uit internationale organisatie (vroeger)
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        align="right"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="loonUitVroegereDienstbetrekkingInternationaleOrganisatie"
                                        id="loonUitVroegereDienstbetrekkingInternationaleOrganisatie"
                                        prefix="€"
                                ></snelstart-ui-number-form-control>
                            </div>
                            <div class="col-3"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <div *ngIf="!this.isDefAangifte" class="pt-3" style="width: 75%">
        <snelstart-ui-alert type="info">
            <div *ngIf="!partnerBoolean">
                <div *ngIf="!this.isDefAangifte && this.aangifte?.box1?.belastbaarLoon?.dubbelePositie !== undefined">
                    <div *ngIf="this.aangifte?.box1?.belastbaarLoon?.dubbelePositie === true">
                        Er is <b>wel</b> sprake van een of meer banen en/of uitkeringen tegelijkertijd.
                    </div>
                    <div *ngIf="this.aangifte?.box1?.belastbaarLoon?.dubbelePositie === false">
                        Er is <b>geen</b> sprake van een of meer banen en/of uitkeringen tegelijkertijd.
                    </div>
                </div>
            </div>
            <div *ngIf="partnerBoolean">
                <div *ngIf="!this.isDefAangifte && this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.dubbelePositie !== undefined">
                    <div *ngIf="this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.dubbelePositie === true">
                        Er is <b>wel</b> sprake van een of meer banen en/of uitkeringen tegelijkertijd.
                    </div>
                    <div *ngIf="this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.dubbelePositie === false">
                        Er is <b>geen</b> sprake van een of meer banen en/of uitkeringen tegelijkertijd.
                    </div>
                </div>
            </div>
        </snelstart-ui-alert>
    </div>

</div>

<div *ngIf="!heeftLoon()">
    <div *ngIf="!partnerBoolean">
        Er is geen loon voor {{ dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen loon voor {{ dataService.naamPartner }} ingevuld.
    </div>
</div>
